var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-oblong",
      class: ["cw-oblong-" + _vm.oblongSize]
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-oblong-value"
        },
        [_vm._t("oblongValue")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-oblong-description"
        },
        [
          _vm.icon
            ? _c("studip-icon", {
                attrs: {
                  shape: _vm.icon,
                  role: "info",
                  size: _vm.iconSize
                }
              })
            : _vm._e(),
          _vm._v(_vm._s(_vm.name) + "\n    ")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }